import { createAsyncThunk } from '@reduxjs/toolkit';
import { asyncRoutes, whiteList } from 'app/configs/routesConfig';
import { filterAsyncRoutes } from 'src/app/routing/utils/resolvers';
import _ from 'lodash';

const defaultOptions = () => ({ filterByScopes: true });

export const buildAsyncRoutesFromScopes = createAsyncThunk(
  'routes/buildAsyncFromScopes',
  async (entryOptions, { getState, rejectWithValue }) => {
    const options = _.merge({}, defaultOptions(), entryOptions);
    try {
      const { profile } = getState();

      const scopes = profile?.scopes ?? [];

      const errors = [];

      if (!Array.isArray(scopes)) {
        errors.push('Scopes must be an array');
      }

      if (errors.length) {
        return rejectWithValue(errors);
      }

      const remaining = asyncRoutes.filter((route) => !whiteList.includes(route.path));
      const filtered = filterAsyncRoutes(remaining, scopes);
      const selected = options.filterByScopes ? filtered : remaining;
      return { remaining, filtered, selected };
    } catch (error) {
      return rejectWithValue([error?.message || 'Failed to build async routes']);
    }
  }
);
